/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateStockItemInput } from '../models/CreateStockItemInput';
import type { PagedStockItemListSchema } from '../models/PagedStockItemListSchema';
import type { StockItemSchema } from '../models/StockItemSchema';
import type { StockItemTotalValuesSchema } from '../models/StockItemTotalValuesSchema';
import type { UpdateStockItemInput } from '../models/UpdateStockItemInput';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StockItemsApi {
    /**
     * Get Stock Item List
     * Get list of stock items. Required Permission: warehouse_stock_item_list
     * @returns PagedStockItemListSchema OK
     * @throws ApiError
     */
    public static warehouseGetStockItemListGet({
        underLimit,
        search = '',
        limit = 100,
        offset,
    }: {
        underLimit?: (boolean | null),
        search?: string,
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedStockItemListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/stock-items/',
            query: {
                'under_limit': underLimit,
                'search': search,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Create Stock Item
     * Create new StockItem. Required Permission: warehouse_stock_item_create
     * @returns StockItemSchema Created
     * @throws ApiError
     */
    public static warehouseCreateStockItemPost({
        requestBody,
    }: {
        requestBody: CreateStockItemInput,
    }): CancelablePromise<StockItemSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/stock-items/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Stock Item Total Values
     * Get total values of stock items. Required Permission: warehouse_stock_item_list
     * @returns StockItemTotalValuesSchema OK
     * @throws ApiError
     */
    public static warehouseGetStockItemTotalValuesGet(): CancelablePromise<StockItemTotalValuesSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/stock-items/total-values/',
        });
    }
    /**
     * Update Stock Item
     * Update StockItem. Required Permission: warehouse_stock_item_update
     * @returns StockItemSchema OK
     * @throws ApiError
     */
    public static warehouseUpdateStockItemPut({
        stockItemId,
        requestBody,
    }: {
        stockItemId: string,
        requestBody: UpdateStockItemInput,
    }): CancelablePromise<StockItemSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/stock-items/{stock_item_id}/',
            path: {
                'stock_item_id': stockItemId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Stock Item
     * Delete StockItem. Required Permission: warehouse_stock_item_delete
     * @returns void
     * @throws ApiError
     */
    public static warehouseDeleteStockItemDelete({
        stockItemId,
    }: {
        stockItemId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/stock-items/{stock_item_id}/',
            path: {
                'stock_item_id': stockItemId,
            },
        });
    }
    /**
     * Get Stock Item
     * Get StockItem. Required Permission: warehouse_stock_item_list
     * @returns StockItemSchema OK
     * @throws ApiError
     */
    public static warehouseGetStockItemGet({
        stockItemId,
    }: {
        stockItemId: string,
    }): CancelablePromise<StockItemSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/stock-items/{stock_item_id}/',
            path: {
                'stock_item_id': stockItemId,
            },
        });
    }
}
